/**
 * @file 绑定信用卡
 * @date 2020/07/28
 */

import React, {Component} from 'react';
import NavBarComponent from '../../component/common/NavBarComponent';
import {NavBar, Icon} from 'antd-mobile';
import {parseSearchToState} from '../../util/util.js';
import {Http} from '../../api/index';
import './index.scss';
import storage from 'store';

class openCard extends Component {
    constructor(props) {
        super(props);
        props.cacheLifecycles.didRecover(this.componentDidRecover);
        this.state = {
            html: ''
        };
    }

    componentDidMount() {
        this.getBindCardHTML();
    }

    componentDidRecover = () => {
        this.getBindCardHTML();
    }

    getBindCardHTML() {
        const {history} = this.props;
        const search = history.location.search;
        let params = parseSearchToState(search);
        setTimeout(() => {
            Http.post({url: '/api/payment/bank/v1/bind.json', data: {
                bankCardNo: params.bankCardNo,
                bankType: params.bankType,
                bankCode: params.bankCode,
                bankName: params.bankName,
                bankPhone: params.bankPhone
            }}).then(res => {
                this.setState({
                    html: res.data.unionHtml
                });
                storage.set('htmlcode', res.data.unionHtml);
            });
        }, 600);
    }

    backPage() {
        const {history} = this.props;
        history.push({
            pathname: '/my'
        });
    }

    render() {
        return (
            <div id="open-card" className="page">
                <NavBarComponent>
                    <NavBar
                        icon={<Icon type="left" color='#333' />}
                        onLeftClick={() => {this.backPage();}}
                        mode='light'>
                        添加信用卡
                    </NavBar>
                </NavBarComponent>
                <div className="iframe-box">
                    {
                        this.state.html ? <iframe src="/frame" className="bank-box"></iframe> : ''
                    }
                </div>
            </div>
        );
    }
}

export default openCard;